import React from 'react';
import { useAuth } from '../../contexts/authContext';

const Header = () => {
    const { userLoggedIn } = useAuth();
    return userLoggedIn ? null : null; // Keep Header empty or add other elements if needed
};

export default Header;